import React, { memo, useEffect, useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import {
    smilDesignQuestionsConfig,
    smilDesignQuestionsConfigFirstFit,
    validationSchema,
    validationSchemaFirstFit,
} from './SmileDesignQuestions';
import loopSmileDesignQuestions from './LoopSmileDesignQuestions';
import { useLang } from '../../util/lang';
import { useSelector } from 'react-redux';

// Usage: this component is used to display the ans filled by user. However, the ans value may change frequently (user's requirement )
// causing the preview component not accurate when mapping the data, thereby using SmileDesignPrescriptionNotesPreviewMap instead of this componentto display the preview data

/**
 * Renders a read-only Smile Design prescription preview.
 */
const SmileDesignPrescriptionNotesPreview = ({
    defaultValues,
    previewAfterSubmitbyisMarieGroup = undefined,
    isMarieGroup = undefined,
    isSEAGroup = undefined,
    schema = undefined,
    isUpsellTab = false,
}) => {
    const get = useLang('@');
    const isMarieGroupMemo = useMemo(() => {
        if (typeof isMarieGroup === 'boolean') return isMarieGroup;
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, [isMarieGroup]);
    const isSEAGroupMemo = useMemo(() => {
        if (typeof isSEAGroup === 'boolean') return isSEAGroup;
        return JSON.parse(localStorage.getItem('isSEAGroup')) || false;
    }, [isSEAGroup]);
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);
    const activeSchema = schema || (displayFirstFitFlag ? validationSchemaFirstFit : validationSchema);

    const methods = useForm({
        resolver: yupResolver(activeSchema),
        defaultValues: defaultValues,
    });

    const formValues = useWatch({ control: methods.control });
    const config = useMemo(() => {
        const questionConfig = displayFirstFitFlag ? smilDesignQuestionsConfigFirstFit : smilDesignQuestionsConfig;
        return questionConfig(
            formValues,
            previewAfterSubmitbyisMarieGroup !== undefined ? previewAfterSubmitbyisMarieGroup : isMarieGroupMemo,
            isUpsellTab,
            false,
            isSEAGroupMemo
        );
    }, [displayFirstFitFlag, formValues, previewAfterSubmitbyisMarieGroup, isMarieGroupMemo, isSEAGroupMemo, isUpsellTab]);

    useEffect(() => {
        methods.reset(defaultValues);
    }, [defaultValues]);

    return (
        <FormProvider {...methods}>
            {
                displayFirstFitFlag && <div style={{ marginBottom: 16 }}>{get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.SectionOne')}</div>
            }
            <div className={displayFirstFitFlag ? "isd-prescription-radio-scope" : undefined}>{loopSmileDesignQuestions(config, formValues, true, get, true, displayFirstFitFlag)}</div>
        </FormProvider>
    );
};

export default memo(SmileDesignPrescriptionNotesPreview);
